import React from "react";

const BreadcrumbIcon = ({ settings, isMobile, icon }) => {
    const { section } = settings;

    return (
        <i
            className={`icon ${icon ?? section.icon}`}
            style={{
                paddingLeft: isMobile ? `${section.spacing_mobile}px` : `${section.spacing}px`,
                fontSize: `${section.icon_size}px`,
            }}
        />
    );
};

export default BreadcrumbIcon;
